import { LOGIN, ROUTES } from '@/services/api';
import { request, METHOD, removeAuthorization } from '@/utils/request';
var BASE_URL = process.env.VUE_APP_API_BASE_URL;

/**
 * 获取发货渠道数据列表（#65）
 */
export function getMerchantChannelList() {
  return request("".concat(BASE_URL) + "/merchantChannel/list", METHOD.GET);
}

/**获取发货渠道数据（#68）
 * @param {Object} id
 */
export function getMerchantChannelDetail(id) {
  return request("".concat(BASE_URL) + "/merchantChannel/" + id, METHOD.GET);
}

/** 编辑发货渠道数据（#67）
 * @param {Object} data
 */
export function updateMerchantChannel(data) {
  return request("".concat(BASE_URL) + "/merchantChannel", METHOD.PUT, data);
}

/** 新建发货渠道数据（#66）
 * @param {Object} data
 */
export function addMerchantChannel(data) {
  return request("".concat(BASE_URL) + "/merchantChannel", METHOD.POST, data);
}

/** 更新发货渠道状态（#69）
 * @param {Object} data
 */
export function updateMerchantChannelStatus(data) {
  return request("".concat(BASE_URL) + "/merchantChannel/status", METHOD.PUT, data);
}